import FeatureLayer from '@arcgis/core/layers/FeatureLayer';
import Field from '@arcgis/core/layers/support/Field';
import LabelClass from '@arcgis/core/layers/support/LabelClass';
import UniqueValueRenderer from '@arcgis/core/renderers/UniqueValueRenderer';
import SimpleMarkerSymbol from '@arcgis/core/symbols/SimpleMarkerSymbol';
import React, { useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next';

export default function useFeatureLayer() {
    const { t, i18n } = useTranslation("naturalForests");

    const clashingSymbol = new SimpleMarkerSymbol({
        color: "red",
        size: "10"
    });

    const nonClashingSymbol = new SimpleMarkerSymbol({
        color: "green",
        size: "10"
    });

    const cutSymbol = new SimpleMarkerSymbol({
        color: "black",
        size: "10"
    });

    const renderByClashing = new UniqueValueRenderer({
        field: "status",
        defaultSymbol: nonClashingSymbol,
        uniqueValueInfos: [
            {
                value: "1",
                symbol: nonClashingSymbol
            },
            {
                value: "2",
                symbol: clashingSymbol
            },
            {
                value: "3",
                symbol: cutSymbol
            }
        ]
    });

    const statesLabelClass = new LabelClass({
        labelExpression: "[name]",
        symbol: {
            type: "text",
            color: "black",
            haloSize: 1,
            font: {
                size: 14
            },
            haloColor: "white",
            //horizontalAlignment: 'center',
            //xoffset: -50,
            //verticalAlignment: 'top'
        }
    });

    const naturalForestPointsLayer = useMemo(() => new FeatureLayer({
        fields: [
            new Field({
                "name": "status",
                "type": "string"
            }),
            new Field({
                "name": "name",
                "type": "string"
            }),
            new Field({
                "name": "latestClash",
                "type": "string"
            })
        ],
        objectIdField: "ObjectID",
        geometryType: "point",
        source: [],
        renderer: renderByClashing,
        title: t("pistekarttatasonNimi"),
        labelsVisible: true,
        labelingInfo: [statesLabelClass],
        maxScale: 100000
    }), []);

    useEffect(() => {
        if (naturalForestPointsLayer) {
            naturalForestPointsLayer.title = t("pistekarttatasonNimi");
        }
    }, [i18n.language, t]);

    return (
        naturalForestPointsLayer
    )
}